
export const Roles = [
    { name: 'Администратор', key: 'admin' },
    { name: 'Организатор', key: 'manager' },
    { name: 'Пользователь', key: 'user' },
]
